import { Component } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'prox-error-dialog',
  template: `
    <div>
      <div class="text-l mb-3 font-bold">{{ data.error.message }}</div>

      <div class="mt-3 text-right">
        <button
          *ngIf="data.canReload"
          (click)="reload()"
          pButton
          type="button"
          icon="pi pi-refresh"
          label="Reload"
          class="p-button-raised p-button-primary mr-3"
        ></button>
        <button (click)="close()" pButton type="button" icon="pi pi-times" label="Close" class="p-button-raised p-button-danger"></button>
      </div>
    </div>
  `,
  standalone: false,
})
export class ErrorDialogComponent {
  data: { error: Error; header?: string; canReload?: boolean };
  constructor(
    dialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
  ) {
    this.data = dialogConfig.data;
  }

  close() {
    this.ref.close();
  }

  reload() {
    location.reload();
  }
}
